<h1 class="my-3 d-print-none"> Hello{{ getName() ? ' ' + getName() : '' }}! </h1>